module.exports = __webpack_public_path__ + "static/media/started.0c0cc759.svg";